// extracted by mini-css-extract-plugin
module.exports = {"phoneChatIcon":"chatorphoneicon_phoneChatIcon__2zNBF","fadein":"chatorphoneicon_fadein__d5lhN","loading":"chatorphoneicon_loading__lGyfc"};